/**
 * Noshi dialog shared helpers for shipping and eGift pages.
 */
(function(window, $) {
  'use strict';

  if (!$) return;

  var PREVIEW_API_ENDPOINT = '/apps/ping/noshi/preview';
  var NOSHI_INVALID_TEXT_MESSAGE = '絵文字や記号は入力できない文字です。他の文字に変更してください。';
  var NOSHI_REQUIRED_TEXT_MESSAGE = '入力してください。';

  var DEFAULT_SELECTORS = {
    modal: '#modalGift',
    inputFields: '[data-noshi-input-fields]',
    normalFields: '[data-noshi-normal-fields]',
    uchiiwaiFields: '[data-noshi-uchiiwai-fields]',
    corpBlock: '#modalGift .js-corpBlock',
    corpToggle: '#modalGift .js-corpToggle',
    corpFields: '#modalGift .js-corpFields',
    nameNote: '[data-noshi-name-note]',
    inputTitle: '[data-noshi-input-title]',
    currentModeInput: '#noshi-current-mode',
    previewSection: '[data-noshi-preview-section]',
    previewButton: '[data-noshi-preview-btn]',
    previewNote: '[data-noshi-preview-note]',
    previewContent: '.js-giftPreview',
    previewTitle: '.js-preview-title',
    previewDesc: '.js-preview-desc',
    previewPersonName: '.js-preview-personName',
    previewImage: '.js-preview-img',
    paperSizeInput: '#noshi-paper-size',
    normalName1: '#noshi-line1',
    normalName2: '#noshi-line2',
    uchiiwaiName: '#noshi-uchiiwai-name',
    uchiiwaiFurigana: '#noshi-uchiiwai-furigana',
    corpCompany: '#corpCompany',
    corpTitle: '#corpTitle',
    corpName: '#corpName'
  };

  function mergeSelectors(overrides) {
    var merged = {};
    var key;
    for (key in DEFAULT_SELECTORS) {
      if (Object.prototype.hasOwnProperty.call(DEFAULT_SELECTORS, key)) {
        merged[key] = DEFAULT_SELECTORS[key];
      }
    }
    if (!overrides) return merged;
    for (key in overrides) {
      if (Object.prototype.hasOwnProperty.call(overrides, key) && overrides[key]) {
        merged[key] = overrides[key];
      }
    }
    return merged;
  }

  function clampText(value, max) {
    return String(value || '').slice(0, max);
  }

  function removeHalfWidthSpaces(value) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/ /g, '');
  }

  function sanitizeNormalNoshiNameValue(value, max) {
    return clampText(removeHalfWidthSpaces(value), max || 8);
  }

  function sanitizeUchiiwaiNoshiValue(value, max) {
    return clampText(removeHalfWidthSpaces(value), max || 8);
  }

  function sanitizeCorporateNoshiCompanyValue(value, max) {
    return clampText(removeHalfWidthSpaces(value), max || 18);
  }

  function sanitizeCorporateNoshiTitleValue(value, max) {
    return clampText(removeHalfWidthSpaces(value), max || 8);
  }

  function sanitizeInputValue($input, sanitizer) {
    if (!$input || !$input.length) return '';

    var currentValue = $input.val();
    var normalizedValue = sanitizer(currentValue);
    if (String(currentValue || '') !== normalizedValue) {
      $input.val(normalizedValue);
    }
    return normalizedValue;
  }

  function sanitizeNormalNoshiNameInput(input, max) {
    var $input = $(input);
    var limit = max || parseInt($input.attr('maxlength'), 10) || 8;
    return sanitizeInputValue($input, function(value) {
      return sanitizeNormalNoshiNameValue(value, limit);
    });
  }

  function normalizeNormalNoshiTexts(options) {
    var selectors = mergeSelectors(options && options.selectors);
    return {
      name1: sanitizeInputValue($(selectors.normalName1), function(value) {
        return sanitizeNormalNoshiNameValue(value, 8);
      }),
      name2: sanitizeInputValue($(selectors.normalName2), function(value) {
        return sanitizeNormalNoshiNameValue(value, 8);
      })
    };
  }

  function sanitizeCorporateNoshiNameInput(input, max) {
    var $input = $(input);
    var limit = max || parseInt($input.attr('maxlength'), 10) || 8;
    return sanitizeInputValue($input, function(value) {
      return sanitizeNormalNoshiNameValue(value, limit);
    });
  }

  function sanitizeCorporateNoshiCompanyInput(input, max) {
    var $input = $(input);
    var limit = max || parseInt($input.attr('maxlength'), 10) || 18;
    return sanitizeInputValue($input, function(value) {
      return sanitizeCorporateNoshiCompanyValue(value, limit);
    });
  }

  function sanitizeCorporateNoshiTitleInput(input, max) {
    var $input = $(input);
    var limit = max || parseInt($input.attr('maxlength'), 10) || 8;
    return sanitizeInputValue($input, function(value) {
      return sanitizeCorporateNoshiTitleValue(value, limit);
    });
  }

  function normalizeCorporateNoshiName(options) {
    var selectors = mergeSelectors(options && options.selectors);
    return sanitizeInputValue($(selectors.corpName), function(value) {
      return sanitizeNormalNoshiNameValue(value, 8);
    });
  }

  function normalizeCorporateNoshiTexts(options) {
    var selectors = mergeSelectors(options && options.selectors);
    return {
      company: sanitizeInputValue($(selectors.corpCompany), function(value) {
        return sanitizeCorporateNoshiCompanyValue(value, 18);
      }),
      title: sanitizeInputValue($(selectors.corpTitle), function(value) {
        return sanitizeCorporateNoshiTitleValue(value, 8);
      }),
      name: sanitizeInputValue($(selectors.corpName), function(value) {
        return sanitizeNormalNoshiNameValue(value, 8);
      })
    };
  }

  function sanitizeUchiiwaiNoshiInput(input, max) {
    var $input = $(input);
    var limit = max || parseInt($input.attr('maxlength'), 10) || 8;
    return sanitizeInputValue($input, function(value) {
      return sanitizeUchiiwaiNoshiValue(value, limit);
    });
  }

  function normalizeUchiiwaiNoshiTexts(options) {
    var selectors = mergeSelectors(options && options.selectors);
    return {
      name: sanitizeInputValue($(selectors.uchiiwaiName), function(value) {
        return sanitizeUchiiwaiNoshiValue(value, 8);
      }),
      furigana: sanitizeInputValue($(selectors.uchiiwaiFurigana), function(value) {
        return sanitizeUchiiwaiNoshiValue(value, 8);
      })
    };
  }

  function isUchiiwaiEntry(entry) {
    return !!(entry && entry.type === '出産祝いのお返し');
  }

  function normalizeInputTextSet(entry) {
    if (!entry || entry.inputTextSet === undefined || entry.inputTextSet === null) return [];

    var raw = entry.inputTextSet;
    var values = [];

    if (Array.isArray(raw)) {
      values = raw.slice();
    } else if (typeof raw === 'string') {
      var text = raw.trim();
      if (!text) return [];
      if (text.charAt(0) === '[') {
        try {
          var parsed = JSON.parse(text);
          if (Array.isArray(parsed)) values = parsed;
        } catch (e) {
          values = [text];
        }
      } else if (text.indexOf(',') !== -1) {
        values = text.split(',');
      } else {
        values = [text];
      }
    } else {
      values = [raw];
    }

    return values
      .map(function(value) { return (value === undefined || value === null) ? '' : String(value).trim(); })
      .filter(function(value) { return value.length > 0; });
  }

  function getEntryInputModes(entry) {
    var inputSet = normalizeInputTextSet(entry);
    var hasInputSetConfig = inputSet.length > 0;

    var allowNormal = inputSet.some(function(value) {
      return value.indexOf('通常セット') !== -1;
    });
    var allowUchiiwai = inputSet.some(function(value) {
      return value.indexOf('お名前+ふりがな') !== -1 || value.indexOf('ふりがな') !== -1;
    });
    var allowCorporate = inputSet.some(function(value) {
      return value.indexOf('法人宛セット') !== -1 || value.indexOf('法人') !== -1;
    });

    // Backward compatibility for entries that do not have input-text-set configured.
    if (!hasInputSetConfig) {
      allowUchiiwai = isUchiiwaiEntry(entry);
      allowNormal = !allowUchiiwai;
      allowCorporate = !allowUchiiwai;
    }

    // Guarantee at least one input mode is visible.
    if (!allowNormal && !allowUchiiwai) {
      if (isUchiiwaiEntry(entry)) allowUchiiwai = true;
      else allowNormal = true;
    }

    return {
      allowNormal: allowNormal,
      allowUchiiwai: allowUchiiwai,
      allowCorporate: allowCorporate,
      defaultMode: allowUchiiwai && !allowNormal ? 'uchiiwai' : 'normal'
    };
  }

  function showInputFieldsForEntry(entry, options) {
    var selectors = mergeSelectors(options && options.selectors);
    var modes = getEntryInputModes(entry);
    var mode = modes.defaultMode;

    $(selectors.normalFields).hide();
    $(selectors.uchiiwaiFields).hide();
    $(selectors.corpToggle).prop('checked', false);
    $(selectors.corpFields).hide();
    $(selectors.corpBlock).toggle(modes.allowCorporate);
    $(selectors.nameNote).show();

    if (mode === 'uchiiwai') {
      $(selectors.inputTitle).text('お名前・ふりがなを入力してください');
      $(selectors.uchiiwaiFields).show();
    } else {
      $(selectors.inputTitle).text('お名前');
      $(selectors.normalFields).show();
    }

    $(selectors.currentModeInput).val(mode);
    $(selectors.inputFields).show();


    return mode;
  }

  function handleCorpToggle(selectedEntry, options) {
    var selectors = mergeSelectors(options && options.selectors);
    var modes = getEntryInputModes(selectedEntry);
    var animateCorpFields = !options || options.animateCorpFields !== false;
    var isChecked = $(selectors.corpToggle).is(':checked');
    var mode = modes.defaultMode;

    if (!modes.allowCorporate) {
      $(selectors.corpToggle).prop('checked', false);
      $(selectors.corpBlock).hide();
      $(selectors.corpFields).hide();
      $(selectors.nameNote).show();
      if (mode === 'uchiiwai') {
        $(selectors.normalFields).hide();
        $(selectors.uchiiwaiFields).show();
      } else {
        $(selectors.uchiiwaiFields).hide();
        $(selectors.normalFields).show();
      }
      $(selectors.currentModeInput).val(mode);
      return mode;
    }

    if (isChecked) {
      $(selectors.normalFields).hide();
      $(selectors.uchiiwaiFields).hide();
      $(selectors.nameNote).hide();
      if (animateCorpFields) {
        $(selectors.corpFields).stop(true, true).slideDown(200);
      } else {
        $(selectors.corpFields).show();
      }
      mode = 'corporate';
    } else {
      if (animateCorpFields) {
        $(selectors.corpFields).stop(true, true).slideUp(200);
      } else {
        $(selectors.corpFields).hide();
      }
      $(selectors.nameNote).show();
      if (mode === 'uchiiwai') {
        $(selectors.normalFields).hide();
        $(selectors.uchiiwaiFields).show();
      } else {
        $(selectors.uchiiwaiFields).hide();
        $(selectors.normalFields).show();
      }
    }

    $(selectors.currentModeInput).val(mode);
    return mode;
  }

  function resetPreviewVisibility(options) {
    var selectors = mergeSelectors(options && options.selectors);
    $(selectors.previewSection).show();
    $(selectors.previewButton).show();
    $(selectors.previewNote).show();
    $(selectors.previewContent).hide();
  }

  function clearValidationErrors(options) {
    var selectors = mergeSelectors(options && options.selectors);
    $(selectors.modal + ' .noshi-field-error').remove();
    $(selectors.modal + ' .is-error').removeClass('is-error');
  }

  function hasInvalidNoshiText(value) {
    if (value === undefined || value === null) return false;
    var text = String(value);
    if (!text) return false;
    if (window.CharValidator) return !!window.CharValidator.validate(text, 'noshi');
    return false;
  }

  function appendValidationError($input, message) {
    var $container = $input.closest('.p-row-item, .p-corp__field');
    if (!$container.length) $container = $input.parent();
    $container.addClass('is-error');
    if ($container.find('.noshi-field-error').length === 0) {
      $container.append('<p class="p-form-error-txt noshi-field-error">' + message + '</p>');
    }
  }

  function checkNoshiTextField($input, value) {
    if (!value) return false;
    if (window.CharValidator) {
      var msg = window.CharValidator.validate(String(value), 'noshi');
      if (msg) {
        appendValidationError($input, msg);
        return true;
      }
    }
    return false;
  }

  function validateFields(mode, options) {
    var selectors = mergeSelectors(options && options.selectors);
    var texts = {};
    var hasErrors = false;

    clearValidationErrors({ selectors: selectors });

    if (mode === 'uchiiwai') {
      texts = normalizeUchiiwaiNoshiTexts({ selectors: selectors });
      if (checkNoshiTextField($(selectors.uchiiwaiName), texts.name)) hasErrors = true;
      if (checkNoshiTextField($(selectors.uchiiwaiFurigana), texts.furigana)) hasErrors = true;
    } else if (mode === 'corporate') {
      texts = normalizeCorporateNoshiTexts({ selectors: selectors });
      // 会社名は半角/全角スペースも禁止
      if (/[\u0020\u3000]/.test(texts.company)) {
        appendValidationError($(selectors.corpCompany), NOSHI_INVALID_TEXT_MESSAGE);
        hasErrors = true;
      } else if (checkNoshiTextField($(selectors.corpCompany), texts.company)) {
        hasErrors = true;
      }
      if (checkNoshiTextField($(selectors.corpTitle), texts.title)) hasErrors = true;
      if (checkNoshiTextField($(selectors.corpName), texts.name)) hasErrors = true;
    } else {
      texts = normalizeNormalNoshiTexts({ selectors: selectors });
      if (checkNoshiTextField($(selectors.normalName1), texts.name1)) hasErrors = true;
      if (checkNoshiTextField($(selectors.normalName2), texts.name2)) hasErrors = true;
    }

    if (hasErrors) return null;
    return texts;
  }

  function buildPreviewNameText(mode, texts) {
    var parts = [];
    var nameText;
    if (mode === 'corporate') {
      if (texts.company) parts.push(texts.company);
      if (texts.title) parts.push(texts.title);
      if (texts.name) parts.push(texts.name);
      return parts.join(' ');
    }

    if (mode === 'uchiiwai') {
      if (!texts.name) return '';
      nameText = texts.name;
      if (texts.furigana) nameText += '（' + texts.furigana + '）';
      return nameText;
    }

    if (texts.name1) parts.push(texts.name1);
    if (texts.name2) parts.push(texts.name2);
    return parts.join(' ');
  }

  function renderPreviewText(entry, mode, texts, options) {
    var selectors = mergeSelectors(options && options.selectors);
    var personName = buildPreviewNameText(mode, texts);

    $(selectors.previewTitle).text((entry && entry.omotegaki) || '—');
    $(selectors.previewDesc).text((entry && entry.name) || '—');
    $(selectors.previewPersonName).text(personName || '—');
  }

  function fetchPreviewImage(entry, mode, texts, options) {
    var selectors = mergeSelectors(options && options.selectors);
    var apiUrl = (options && options.apiUrl) || PREVIEW_API_ENDPOINT;

    if (!entry) return null;

    var requestBody = {
      paper_size: $(selectors.paperSizeInput).val() || 'A4',
      metaobject_id: entry.gid || '',
      mode: mode,
      texts: texts,
      options: { format: 'png', scale: 0.5 }
    };

    $(selectors.previewImage).css('opacity', '0.5');

    return $.ajax({
      url: apiUrl,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(requestBody),
      success: function(data) {
        if (data && data.image && data.image.data_url) {
          $(selectors.previewImage).attr('src', data.image.data_url);
        }
      },
      complete: function() {
        $(selectors.previewImage).css('opacity', '1');
      }
    });
  }

  window.NoshiDialogCommon = {
    PREVIEW_API_ENDPOINT: PREVIEW_API_ENDPOINT,
    isUchiiwaiEntry: isUchiiwaiEntry,
    getEntryInputModes: getEntryInputModes,
    removeHalfWidthSpaces: removeHalfWidthSpaces,
    sanitizeNormalNoshiNameInput: sanitizeNormalNoshiNameInput,
    normalizeNormalNoshiTexts: normalizeNormalNoshiTexts,
    sanitizeUchiiwaiNoshiInput: sanitizeUchiiwaiNoshiInput,
    normalizeUchiiwaiNoshiTexts: normalizeUchiiwaiNoshiTexts,
    sanitizeCorporateNoshiCompanyInput: sanitizeCorporateNoshiCompanyInput,
    sanitizeCorporateNoshiTitleInput: sanitizeCorporateNoshiTitleInput,
    sanitizeCorporateNoshiNameInput: sanitizeCorporateNoshiNameInput,
    normalizeCorporateNoshiName: normalizeCorporateNoshiName,
    normalizeCorporateNoshiTexts: normalizeCorporateNoshiTexts,
    showInputFieldsForEntry: showInputFieldsForEntry,
    handleCorpToggle: handleCorpToggle,
    resetPreviewVisibility: resetPreviewVisibility,
    clearValidationErrors: clearValidationErrors,
    validateFields: validateFields,
    buildPreviewNameText: buildPreviewNameText,
    renderPreviewText: renderPreviewText,
    fetchPreviewImage: fetchPreviewImage
  };
})(window, window.jQuery);
